export const hints: Record<string, string> = {
  min: 'min',
  lowercase: 'lowercase',
  uppercase: 'uppercase',
  digits: 'digits',
  symbols: 'symbols',
}
